export const fromUpperCaseToUnderScore = data => {
  const finalData = {};
  Object.keys(data).forEach(key => {
    const partialArray = key.split(/(?=[A-Z])/);
    let finalObjectKey = '';
    for (const part of partialArray) {
      finalObjectKey += `${part.toLowerCase()}_`;
    }
    finalObjectKey = finalObjectKey.slice(0, -1);
    finalData[finalObjectKey] = data[key];
  });
  return finalData;
};

export const fromUnderScoreToUpperCase = data => {
  const finalData = {};
  Object.keys(data).forEach(key => {
    const partialArray = key.split('_');
    if (partialArray.length === 1) {
      finalData[key] = data[key];
    } else {
      let finalObjectKey = partialArray[0];
      partialArray.shift();
      for (const part of partialArray) {
        finalObjectKey +=
          part.substring(0, 1).toUpperCase() + part.substring(1);
      }
      finalData[finalObjectKey] = data[key];
    }
  });
  return finalData;
};
